const usePermissionConfig = () => {
  return {
    // 新增
    XZ: 'XMFWGL-XMFW-XZ',
    // 批量编辑
    PLBJ: 'XMFWGL-XMFW-PLBJ',
    // 编辑
    BJ: 'XMFWGL-XMFW-BJ',
    // 后端服务
    // HDFW: 'XMFWGL-XMFW-HDFW',
  };
};

export default usePermissionConfig;
